import { gql } from '../../../apollo/__generated__';

export const CURRENT_USER_REMAINING_SUPER_LIKES = gql(`
  query CurrentUserRemainingSuperLikes($eventId: ID!) {
    currentUser {
      id
      remainingSuperLikes(eventId: $eventId)
    }
  }
`);
